function exists (state) {
  const session = get(state)
  return session !== null
}

function get (state) {
  let session = state.session
  if (session === null && sessionStorage) {
    // try getting that from session storage
    session = sessionStorage.getItem("session")
    if (session !== null) {
      session = JSON.parse(session)
      const t = session.t
      const delta = Date.now() - t
      if (delta > 3600000 /* 1 hour */) {
        session = null
      }
    }
  }
  return session
}

export { exists, get }
